import { IconProp } from "@fortawesome/fontawesome-svg-core"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Button, Space } from "antd"
import { CSSProperties } from "react"

type ButtonTypes = 'dashed' | 'default' | 'link' | 'primary' | 'text'
type ButtonSizes = 'large' | 'middle' | 'small'

export type Props = {
  icon: IconProp
  text: string
  type?: ButtonTypes
  size?: ButtonSizes
  disabled?: boolean
  danger?: boolean
  loading?: boolean
  style?: CSSProperties
  ghost?: boolean
  onClick?: (e: React.MouseEvent) => void
}

const IconAndTextButton = ({icon, text, type, size, ghost, disabled, danger, loading, style, onClick}: Props) => {
  return <Button
    size={size}
    type={type}
    disabled={disabled}
    danger={danger}
    onClick={onClick}
    loading={loading}
    style={style}
    ghost={ghost}
  >
    <Space>
      <FontAwesomeIcon icon={icon} />
      {text}
    </Space>
  </Button>
}

export default IconAndTextButton